import { useEffect } from "react";
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { EventType } from "@azure/msal-browser";

import Typography from "@mui/material/Typography";

import Box from "ui/atom/Box";
import Button from "ui/base/Button";

import { useLayoutMsal } from "features/layout/fabric";


Msal.Body = ({ children }) => {
	const { instance } = useMsal();
	const active = instance.controller?.initialized && instance.getActiveAccount();

	const handleLogin = () => instance.loginRedirect({ prompt: "select_account" });

	const style = {
		root: {
			alignItems: "center",
			justifyContent: "center",
			maxWidth: "sm",
			margin: "auto",
			height: "100vh"
		}
	};

	if (active) return (
		<AuthenticatedTemplate>
			{children}
		</AuthenticatedTemplate>
	);

	return (
		<UnauthenticatedTemplate>
			<Box.Column gap={2} sx={style.root} >
				<Typography variant="h2">You are not signed in</Typography>
				<Button variant="contained" color="secondary" onClick={handleLogin}>Sign in</Button>
			</Box.Column>
		</UnauthenticatedTemplate>
	);
};

export default function Msal({ children }) {
	const layout = useLayoutMsal();

	useEffect(() => {
		layout.msal.initialize()
			.then(() => {
				if (!layout.msal.getActiveAccount() && layout.msal.getAllAccounts().length > 0) layout.msal.setActiveAccount(layout.msal.getAllAccounts()[0]);

				layout.msal.enableAccountStorageEvents();
				layout.msal.addEventCallback((event) => {
					var authenticationResult = event?.payload;
					if (event.eventType === EventType.LOGIN_SUCCESS && authenticationResult?.account) {
						const account = authenticationResult?.account;
						layout.msal.setActiveAccount(account);
						window.location.reload();
					}
				});
			});
	}, []);

	if (layout.msal) return (
		<MsalProvider instance={layout.msal}>
			<Msal.Body>
				{children}
			</Msal.Body>
		</MsalProvider>
	);
}